import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroupText,
  InputGroupAddon,
  InputGroup,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Vouchers_By_Id,
  gAPI_QuestionOptionList,
  gAPI_RatePlans_List,
  gAPI_Rooms_List,
  gAPI_RatePlans_By_Id,
} from '../../../../../../../constants/APIs';
import IntlMessages from '../../../../../../../helpers/IntlMessages';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
function BuyOptionForm({
  visible,
  toggle,
  formLabel,
  submit,
  updateVoucherData,
  id,
  extractData,
  propertyId,
  locale,
  optionId,
  update,
}) {
  const [isActive, setisActive] = useState(update);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [voucherData, setVoucherData] = useState(
    updateVoucherData || {
      groupId: getGroupID(),
      propertyId: propertyId,
      name: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      introduction: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      details: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      conditions: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      status: 'Draft',
      price: 0,
      discountedPrice: 0,
      discount: 0,
      totalPurchaseLimit: 0,
      orderPurchaseLimit: 0,
      startDate: moment().format('YYYY-MM-DD'),
      expiryDate: moment().add(30, 'days').format('YYYY-MM-DD'),
      creator: 'Admin',
      sellingOptions: [],
      displayOrder: 1,
      searchTags: [],
      images: [],
      options: true,
      inventoryOptionLevel: false,
      giftEnabled: false,
      location: '',
      category: '',
      provider: '',
      includedItems: '',
      redeemOption: '',
    }
  );
  const [rateList, setRateList] = useState([]);
  const [roomList, setLinkRoomList] = useState([]);
  useEffect(() => {
    LoadRatePlanData();
    if (id !== undefined) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Vouchers_By_Id}/${id}`,
      })
        .then((res) => {
          if (!update) {
            setVoucherData({
              ...voucherData,
              sellingOptions: [
                {
                  iscreate: true,
                  option: '',
                  price: 0,
                  discountedPrice: 0,
                  discount: 0,
                  totalPurchaseLimit: 0,
                  orderPurchaseLimit: 0,
                  status: 'Active',

                  roomSettings: {
                    id: '',
                    addons: false,
                    noOfChildren: 0,
                    noOfAdults: 0,
                    noOfNights: 0,
                    isratePlan: false,
                    noOfRooms: 0,
                    rooms: '',
                    ratePlanId: '00000000-0000-0000-0000-000000000000',
                    includeRatePlanAddons: false,
                  },
                  displayOrder: 1,
                  instruction: [
                    {
                      statement: '',
                      languageCode: locale,
                    },
                  ],
                  url: '',
                  id: createUUID(),
                },
              ],
            });
          } else {
            let option = res.data.sellingOptions.filter(
              (s) => s.id === optionId
            );
            res.data.sellingOptions = [option[0]];
            handleChange(option[0].roomSettings.ratePlanId);
            setVoucherData(res.data);
            //console.log(res.data);
          }
          AxiosAPI({
            method: 'get',
            url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Vouchers`,
          })
            .then((res1) => {
              var options = [];
              try {
                res1.data.map((item) =>
                  options.push({
                    label: item.option,
                    value: item.option,
                    key: item.id,
                  })
                );
              } finally {
              }
              setTags(options);
              var selectedTags = [];
              try {
                res.data.searchTags.map((item) =>
                  selectedTags.push(
                    options.filter((cat) => cat.value === item)[0]
                  )
                );
              } finally {
              }
              setselectedTags(selectedTags);
            })
            .catch((err) => console.log('err', err));
        })
        .catch((err) => console.log('err', err));
    }
  }, [id]);

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };

  const handleRemoveDates = (index, optionId) => {
    const values = [...voucherData.sellingOptions];

    //values.splice(index, 1);
    if (optionId !== undefined && optionId !== '' && id !== undefined) {
      const option = values.filter((m) => m.id === optionId);
      option[0].status = 'Archived';
    } else {
      values.splice(index, 1);
    }

    setVoucherData({ ...voucherData, sellingOptions: values });
  };
  const handleInstruction = (source, data, optionId) => {
    if (source === 'user') {
      setVoucherData({
        ...voucherData,
        sellingOptions: voucherData.sellingOptions.map((m) => {
          if (m.id === optionId) {
            m.instruction = [
              {
                statement: data,
                languageCode: locale,
              },
            ];
          }
          return m;
        }),
      });
    }
  };
  const LoadRatePlanData = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_RatePlans_List}/?propertyId=${propertyId}&status=all&languageCode=${locale}`,
    })
      .then((res) => {
        setRateList(res.data.ratePlans);
      })
      .catch((err) => console.log('err', err));
  };

  const handleSubmit = () => {
    submit(voucherData);
    toggle();
  };

  const createUUID = () => {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const handleOptionInputChange = (name, event, optionId) => {
    switch (name) {
      case 'option':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.option = event;
            }
            return m;
          }),
        });
        break;
      case 'price':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.price = event;
              m.discountedPrice = Math.round(
                parseFloat(event) -
                (parseFloat(event) * parseFloat(m.discount)) / 100
              );
            }
            return m;
          }),
        });
        break;
      case 'discount':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.discount = event;
              m.discountedPrice = Math.round(
                parseFloat(m.price) -
                (parseFloat(m.price) * parseFloat(event)) / 100
              );
            }
            return m;
          }),
        });
        break;
      case 'discountedPrice':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.discountedPrice = event;
            }
            return m;
          }),
        });

        break;
      case 'totalPurchaseLimit':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.totalPurchaseLimit = event;
            }
            return m;
          }),
        });
        break;
      case 'status':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.status = event;
            }
            return m;
          }),
        });
        break;
      case 'orderPurchaseLimit':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.orderPurchaseLimit = event;
            }
            return m;
          }),
        });
        break;
      case 'displayOrder':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.displayOrder = event;
            }
            return m;
          }),
        });
        break;

      case 'url':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.url = event;
            }
            return m;
          }),
        });
        break;
      case 'noOfAdults':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.roomSettings.noOfAdults = event;
            }
            return m;
          }),
        });
        break;
      case 'noOfChildren':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.roomSettings.noOfChildren = event;
            }
            return m;
          }),
        });
        break;
      case 'noOfNights':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.roomSettings.noOfNights = event;
            }
            return m;
          }),
        });
        break;
      case 'noOfRooms':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.roomSettings.noOfRooms = event;
            }
            return m;
          }),
        });
        break;
      case 'ratePlan':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.roomSettings.id = event;
              m.roomSettings.ratePlanId = event;
              m.roomSettings.rooms = '';
              handleChange(event);
            }
            return m;
          }),
        });
        break;
      case 'addons':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              if (m.roomSettings.addons) {
                m.roomSettings.addons = false;
              } else {
                m.roomSettings.addons = true;
              }
            }
            return m;
          }),
        });
        break;
      case 'room':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.roomSettings.rooms = event;
              handleChange(event);
            }
            return m;
          }),
        });
        break;
      default:
        break;
    }
  };

  const handleChange = (id) => {
    if (id !== '00000000-0000-0000-0000-000000000000') {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Rooms_List}/?propertyId=${propertyId}`,
      })
        .then((response) => {
          AxiosAPI({
            methhod: 'get',
            url: `${gAPI_RatePlans_By_Id}/${id}`,
          })
            .then((res) => {
              let val = [];
              response.data.rooms.map((m) => {
                res.data.rooms.map((r) => {
                  if (r.id === m.id) {
                    val.push({
                      id: m.id,
                      name: m.name,
                    });
                  }
                });
              });
              //console.log(val);
              setLinkRoomList(val);
            })
            .catch((err) => {
              console.log('err', err);
            });
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  };

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggle}
        size="lg"
        style={{ maxWidth: '1000px' }}
      >
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          {voucherData.options &&
            voucherData.sellingOptions !== undefined &&
            voucherData.sellingOptions.length > 0
            ? voucherData.sellingOptions
              .filter((m) => {
                if (
                  update
                    ? m.status !== 'Archived' &&
                    (optionId !== undefined ? m.id === optionId : true)
                    : m.iscreate == true && m.status !== 'Archived'
                ) {
                  return m;
                }
              })
              .map((tariff, index) => (
                <Row key={`${tariff}~${index}`}>
                  <Colxx sm={12} className="mb-3">
                    <Label>Option</Label>
                    <Input
                      required
                      type="text"
                      name="option"
                      value={tariff.option}
                      onChange={(event) =>
                        handleOptionInputChange(
                          event.target.name,
                          event.target.value,
                          tariff.id
                        )
                      }
                    />
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>Price</Label>
                    <Input
                      type="number"
                      min={0}
                      value={tariff.price}
                      name="price"
                      onChange={(event) =>
                        handleOptionInputChange(
                          event.target.name,
                          event.target.value,
                          tariff.id
                        )
                      }
                    />
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>Discount</Label>
                    <InputGroup>
                      <Input
                        type="number"
                        min={0}
                        value={tariff.discount}
                        name="discount"
                        onChange={(event) =>
                          handleOptionInputChange(
                            event.target.name,
                            event.target.value,
                            tariff.id
                          )
                        }
                      />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>%</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>Price After Discount</Label>
                    <Input
                      type="number"
                      min={0}
                      value={tariff.discountedPrice}
                      name="discountedPrice"
                      onChange={(event) =>
                        handleOptionInputChange(
                          event.target.name,
                          event.target.value,
                          tariff.id
                        )
                      }
                    />
                  </Colxx>
                  {/* {voucherData.redeemOption === 'BookMeBob' &&
                                        voucherData.category === 'Accommodation' ? (
                                        <Fragment>
                                            <Colxx sm={3} className="mb-3">
                                                <Label>No. of Adults</Label>
                                                <Input
                                                    type="number"
                                                    value={tariff.roomSettings.noOfAdults}
                                                    name="noOfAdults"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            <Colxx sm={3} className="mb-3">
                                                <Label> No. of Children </Label>
                                                <Input
                                                    type="number"
                                                    value={tariff.roomSettings.noOfChildren}
                                                    name="noOfChildren"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            <Colxx sm={3} className="mb-3">
                                                <Label>No. of Nights</Label>
                                                <Input
                                                    type="number"
                                                    value={tariff.roomSettings.noOfNights}
                                                    name="noOfNights"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            <Colxx sm={3} className="mb-3">
                                                <Label>No. of Rooms</Label>
                                                <Input
                                                    type="number"
                                                    value={tariff.roomSettings.noOfRooms}
                                                    name="noOfRooms"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                />
                                            </Colxx>
                                            {tariff.roomSettings.id !== '' && (
                                                <Colxx sm={3} className="mb-3">
                                                    <Label>Rate Plan Add-on's</Label>
                                                    <CustomInput
                                                        type="checkbox"
                                                        checked={tariff.roomSettings.addons}
                                                        name="addons"
                                                        onChange={(event) =>
                                                            handleOptionInputChange(
                                                                event.target.name,
                                                                event.target.value,
                                                                tariff.id
                                                            )
                                                        }
                                                    ></CustomInput>
                                                </Colxx>
                                            )}
                                            <Colxx sm={6} className="mb-3">
                                                <Label>Rate Plan</Label>
                                                <Input
                                                    type="select"
                                                    value={tariff.roomSettings.ratePlanId}
                                                    name="ratePlan"
                                                    onChange={(event) =>
                                                        handleOptionInputChange(
                                                            event.target.name,
                                                            event.target.value,
                                                            tariff.id
                                                        )
                                                    }
                                                >
                                                    <option value="00000000-0000-0000-0000-000000000000">
                                                        Choose One
                                                    </option>
                                                    {rateList.length > 0 &&
                                                        rateList.map((r, index) => {
                                                            return (
                                                                <option key={index} value={r.id}>
                                                                    {r.name}
                                                                </option>
                                                            );
                                                        })}
                                                </Input>
                                            </Colxx>

                                            {
                                                <Colxx sm={6} className="mb-3">
                                                    <Label>Room</Label>
                                                    <Input
                                                        type="select"
                                                        name="room"
                                                        value={tariff.roomSettings.rooms}
                                                        onChange={(event) =>
                                                            handleOptionInputChange(
                                                                event.target.name,
                                                                event.target.value,
                                                                tariff.id
                                                            )
                                                        }
                                                    >
                                                        {roomList.length > 0 &&
                                                            roomList.map((r, index) => {
                                                                return (
                                                                    <option key={index} value={r.id}>
                                                                        {r.name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </Input>
                                                </Colxx>
                                            }
                                        </Fragment>
                                    ) : null} */}
                  {voucherData.inventoryOptionLevel && (
                    <Fragment>
                      <Colxx sm={3} className="mb-3">
                        <Label>Total Available to Sell</Label>
                        <Input
                          type="number"
                          min={0}
                          value={tariff.totalPurchaseLimit}
                          name="totalPurchaseLimit"
                          onChange={(event) =>
                            handleOptionInputChange(
                              event.target.name,
                              event.target.value,
                              tariff.id
                            )
                          }
                        />
                      </Colxx>
                      <Colxx sm={3} className="mb-3">
                        <Label>Order Purchase Limit</Label>
                        <Input
                          type="number"
                          min={0}
                          value={tariff.orderPurchaseLimit}
                          name="orderPurchaseLimit"
                          onChange={(event) =>
                            handleOptionInputChange(
                              event.target.name,
                              event.target.value,
                              tariff.id
                            )
                          }
                        />
                      </Colxx>
                    </Fragment>
                  )}{' '}
                  <Colxx sm={3} className="mb-3">
                    <Label>Status</Label>
                    <Input
                      type="select"
                      value={tariff.status}
                      name="status"
                      onChange={(event) =>
                        handleOptionInputChange(
                          event.target.name,
                          event.target.value,
                          tariff.id
                        )
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={3}>
                    <Label for="displayOrder"><IntlMessages id='dashboards.displayOrder' /> </Label>
                    <Input
                      type="number"
                      name="displayOrder"
                      min={0}
                      value={tariff.displayOrder}
                      onChange={(event) =>
                        handleOptionInputChange(
                          event.target.name,
                          event.target.value,
                          tariff.id
                        )
                      }
                    />
                  </Colxx>
                  {/* {voucherData.redeemOption === 'ExternalLink' && (
                                        <Colxx sm={6} className="mb-3">
                                            <Label>Url</Label>
                                            <Input
                                                type="text"
                                                value={tariff.url}
                                                name="url"
                                                onChange={(event) =>
                                                    handleOptionInputChange(
                                                        event.target.name,
                                                        event.target.value,
                                                        tariff.id
                                                    )
                                                }
                                            />
                                        </Colxx>
                                    )} */}
                  {voucherData.redeemOption !== 'BookMeBob' && (
                    <Colxx sm={6} className="mb-3">
                      <Label>Instructions</Label>
                      <ReactQuill
                        theme="snow"
                        value={getLocalStatement(tariff.instruction)}
                        onChange={(content, delta, source) => {
                          handleInstruction(source, content, tariff.id);
                        }}
                        modules={quillModules}
                        formats={quillFormats}
                        name="instruction"
                      />
                    </Colxx>
                  )}
                </Row>
              ))
            : null}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              handleSubmit();
              extractData();
            }}
          >
            Save
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setVoucherData({ ...voucherData, sellingOptions: [] });
              toggle();
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      {/* {!update && handleAddOptions()} */}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(BuyOptionForm));
